module.exports = __webpack_public_path__ + "static/media/Plague.7e765b10.jpg";